// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vtvdY {\n  /* Design spec */\n  width: 335px;\n}\n\n.c7cL4 {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.Q3esZ {\n  margin-bottom: var(--spacing-md);\n}\n\n.Q3esZ input {\n  font-family: var(--font-family-signature);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "vtvdY",
	"checkbox": "c7cL4",
	"signature": "Q3esZ"
};
export default ___CSS_LOADER_EXPORT___;
